import slugify from "@sindresorhus/slugify";

const siteUrl = import.meta.env.SITE_URL;

export default {
  fetchJobs: async () => {
    console.log("Calling Career API ===============================");

    const raw = await fetch(
      "https://api.careerpuck.com/v1/public/job-boards/atlan/lever"
    );
    const rawJson = await raw.json();
    const jobs = rawJson.map((x) => ({ ...x }));

    const formattedJobs = jobs.map((position) => {
      const teamName = position.categories.team;

      let templateId = slugify(teamName || "", {
        customReplacements: [["'", ""]],
      });
      let slug = slugify(position.text, {
        customReplacements: [["'", ""]],
      });
      if (templateId === "internships") {
        if (
          slug === "data-parsing-internship" ||
          slug === "data-science-internship"
        ) {
          templateId = "internships-ds";
        } else {
          templateId = "internships-product";
        }
      }
      // console.log("templateId", templateId);
      const res = {
        team: teamName,
        id: position.id,
        text: position.text,
        location: position.categories.location,
        url: `/careers${templateId ? `/${templateId}` : ``}/${slug}/${
          position.id
        }`,
        category: templateId.toLocaleLowerCase(),
        slug,
      };
      return res;
    });

    const mapJobs = formattedJobs.map((job, index) => ({
      params: {
        slug: `careers${job.category ? `/${job.category}` : ``}/${job.slug}/${
          job.id
        }`,
      },
      props: {
        title: `Atlan | Careers | ${job.text}`,
        layout: "career",
        job: jobs[index],
        formattedJob: job,
        ogImage: `${siteUrl}/og/${job.url.replace(/\//g, "-")}.png`,
        pageExt: {
          noSitemap: true,
          og: {
            template: "careers",
            title: job.text,
            location: job.location,
            type: jobs[index].categories?.commitment,
            // category: job.categories ? job.categories.location : ""
          },
        },
        meta: [
          {
            name: "description",
            content:
              "We're on a mission to help data teams around the world do their lives' best work. Join our growing team at Atlan!",
          },
          {
            name: "keywords",
            content:
              "atlan careers, atlan engineering, atlan positions, atlan jobs, engineering, internship",
          },
          { name: "robots", content: "index, follow" },
          { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
          { name: "language", content: "English" },
          {
            property: "og:title",
            content: `Atlan | Careers | ${job.text}`,
          },
          {
            property: "og:description",
            content:
              "We're on a mission to help data teams around the world do their lives' best work. Join our growing team at Atlan!",
          },
          { property: "og:type", content: "Website" },
          { property: "og:site_name", content: "Atlan" },
          { property: "og:url", content: "https://atlan.com/careers" },
          {
            property: "og:image",
            content: job.url
              ? `${siteUrl}/og/${job.url
                  .replace(/^\/|\/$/g, "")
                  .replace(/\//g, "-")}.png`
              : "https://website-assets.atlan.com/img/atlan-card.jpg",
          },
          { name: "twitter:card", content: "summary" },
        ],
      },
    }));
    return mapJobs;
  },
};
